import { render, staticRenderFns } from "./Logistic.vue?vue&type=template&id=a26f31d4&"
import script from "./Logistic.vue?vue&type=script&lang=js&"
export * from "./Logistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports